
import { Component } from 'vue-property-decorator';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import {
    DeleteTopicRequest,
    Topic,
    PostTopicRequest,
    PutTopicRequest,
} from '@/model/Topic';
import ToastVariant from '@/model/enums/toast/toast-variant';
import { mixins } from 'vue-class-component';
import ToastMixin from '@/mixins/ToastMixin';
import { ApiError } from '@/model/ApiError';
import LocationTopicResoposibleTable from '@/components/master-data/LocationTopicResponsibleTable.vue';

@Component({
    components: {
        LocationTopicResoposibleTable,
    },
    methods: {
        ...mapActions({
            fetchTopics: 'topicsStorage/fetchTopics',
            deleteTopic: 'topicsStorage/deleteTopic',
            putTopic: 'topicsStorage/putTopic',
            postTopic: 'topicsStorage/postTopic',
        }),
        ...mapMutations({
            setTopics: 'topicsStorage/setTopics',
        }),
    },
    computed: {
        ...mapGetters({
            getTopics: 'topicsStorage/getTopics',
            getError: 'topicsStorage/getError',
        }),
    },
})
export default class Topics extends mixins(ToastMixin) {
    fetchTopics!: (eventId: number) => Promise<void | Topic[]>;

    deleteTopic!: (deleteTopicRequest: DeleteTopicRequest) => Promise<void>;

    putTopic!: (putTopicRequest: PutTopicRequest) => Promise<void>;

    postTopic!: (postTopicRequest: PostTopicRequest) => Promise<void>;

    setTopics!: (invitedUsers: Topic[] | null) => void;

    getTopics!: Topic[] | null;

    getError!: ApiError | null;

    eventId: number = +this.$route.params.id;

    loading = false;

    mounted(): void {
        this.loading = true;
        this.$store.commit('topicsStorage/setError', null);
        Promise.all([this.fetchTopics(this.eventId)])
            .catch((error) => {
                this.$store.commit('topicsStorage/setError', error);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    destroyed(): void {
        this.setTopics(new Array<Topic>());
    }

    onRemove(topic: Topic): void {
        this.deleteTopic({
            eventId: this.eventId,
            topicId: topic.id,
        })
            .then(() => {
                this.fetchTopics(this.eventId);
                this.showToast(
                    this.$t('topic.toast.delete.succes').toString(),
                    this.$t('topic.toast.delete.title').toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .catch(() => {
                if (this.getError?.key) {
                    if (this.getError?.key === 'has-event-item.topic') {
                        this.showToast(
                            this.$t(`${this.getError.key}`).toString(),
                            this.$t('topic.toast.delete.title').toString(),
                            ToastVariant.DANGER,
                        );
                    }
                }
            });
    }

    onAdd(topic: Topic | null): void {
        if (topic === null) {
            return;
        }
        this.postTopic({
            topic,
            eventId: this.eventId,
        }).then(() => {
            this.fetchTopics(this.eventId);
            this.showToast(
                this.$t('topic.toast.add.succes').toString(),
                this.$t('topic.toast.add.title').toString(),
                ToastVariant.SUCCESS,
            );
        });
    }

    onSaveEdit(topic: Topic): void {
        this.putTopic({
            topic,
            eventId: this.eventId,
        })
            .then(() => {
                this.fetchTopics(this.eventId);
                this.showToast(
                    this.$t('topic.toast.edit.succes').toString(),
                    this.$t('topic.toast.edit.title').toString(),
                    ToastVariant.SUCCESS,
                );
            })
            .catch(() => {
                if (this.getError?.key) {
                    if (this.getError?.key === 'validation.field-invalid') {
                        this.showToast(
                            this.$t(
                                `${this.getError?.validationMessages?.name}`,
                            ).toString(),
                            this.$t('topic.toast.edit.title').toString(),
                            ToastVariant.DANGER,
                        );
                    } else if (
                        this.getError?.key === 'already-exist.topic-in-event'
                    ) {
                        this.showToast(
                            this.$t(`${this.getError.key}`).toString(),
                            this.$t('topic.toast.edit.title').toString(),
                            ToastVariant.DANGER,
                        );
                    }
                }
            });
    }
}
